import React from 'react';
export function Footer() {
  return <footer className="w-full bg-charcoal px-4 pb-28 pt-12 sm:px-6 sm:pb-32" data-id="element-184" data-mp="19j53j40hsmi0">
      <div className="mx-auto w-full max-w-2xl text-center" data-id="element-185" data-mp="206j6dqqc6pi3">
        <p className="flex items-center justify-center gap-2 text-sm font-extrabold uppercase tracking-[0.22em] text-white" data-id="element-186" data-mp="2f4jva0sss12q">
          <span aria-hidden="true" data-id="element-187" data-mp="2a5gwuz7bot3q">🩺</span>
          Dr. <span className="text-blood" data-id="element-188" data-mp="2a3nuvx7nmx22">Karito</span>
        </p>
        <p className="mx-auto mt-5 max-w-xl text-[12px] leading-relaxed text-white/45" data-id="element-189" data-mp="1mgxrarfnqufc">
          Hypertension Route is an educational resource intended for healthcare
          professionals. It does not replace clinical judgment, professional
          guidelines, or the physician-patient relationship.
        </p>
        <p className="mt-5 text-[11px] font-medium uppercase tracking-[0.14em] text-white/35" data-id="element-190" data-mp="1rdxy54kc017i">
          © 2026 Dr. Karito · All rights reserved
        </p>
      </div>
    </footer>;
}